import MainNavigationNavigationItem from "components/MainNavigation/components/elements/NavigationItem";
import { MainNavigationItem } from "components/MainNavigation/types";

type MainNavigationListItemProps = {
  item: MainNavigationItem;
};

const MainNavigationListItem = ({ item }: MainNavigationListItemProps) => {
  if (!("items" in item) && item.announcement) {
    const Announcement = item.announcement;

    return <Announcement item={item} />;
  }

  return <MainNavigationNavigationItem item={item} />;
};

export default MainNavigationListItem;
